import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LancamentoNotasLayer from "../components/LancamentoNotasLayer";
import { useTranslation } from "../i18n/I18nContext";

const LancamentoNotasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("nota.breadcrumb.lancamento")} />
      <LancamentoNotasLayer />
    </MasterLayout>
  );
};

export default LancamentoNotasPage;
